<template>
  <v-container style="max-width: 950px">
    <v-card>
      <v-container fluid>
         <v-layout justify-center>
          <h2 class="primary--text text-uppercase">{{$t('reservas.comprador.lectorDNI')}}</h2>
        </v-layout>
        <v-layout mb-3 row align-center justify-center>
          <v-divider class="dividerTitle primary"></v-divider>
        </v-layout>
        <o-base-center-text>
          <v-flex>
            {{error ? $t('reservas.comprador.avisoDniScannerError') : $t('reservas.comprador.avisoDniScanner')}}
          </v-flex>
        </o-base-center-text>
        <v-responsive v-if="!isiOS && !error" class="mb-3" :aspect-ratio="16/9" justify-center>
          <video width="100%" height="100%" ref="video" class="camera-stream"/>
        </v-responsive>
        <v-layout justify-center>
          <div v-if="isiOS" style="position:relative;overflow:hidden;">
            <input v-if="isiOS" type="file" name="video" ref="input" accept="image/*" capture="environment" @change="grabFrameiOS" id="hiddenInput">
            <v-btn
              tag="label"
              for="hiddenInput"
              large color="primary"
              :disabled="waitingForLoad"
              :loading="waitingForLoad"
            >
              {{$t('reservas.comprador.abrirCamara')}}
            </v-btn>
          </div>
          <v-btn
            v-if="!isiOS && !error"
            large color="primary"
            @click="grabFrame()"
            :disabled="waitingForLoad"
            :loading="waitingForLoad"
          >
            {{$t('reservas.comprador.scan')}}
          </v-btn>
          <v-btn
            v-if="error"
            large color="primary"
            @click="salir()"
            :disabled="waitingForLoad"
            :loading="waitingForLoad"
          >
            {{$t('reservas.comprador.aceptar')}}
          </v-btn>
        </v-layout>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    comprador: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      imageCapture: null,
      track: null,
      mediaStream: null,
      base64: null,
      waitingForLoad: true,
      error: false
    }
  },
  async mounted () {
    try {
      if (!this.isiOS) {
        this.mediaStream = await navigator.mediaDevices.getUserMedia({
          video: {
            width: 1280,
            height: 720,
            facingMode: 'environment'
          }
        })
        this.$refs.video.setAttribute('playsinline', true)
        this.$refs.video.srcObject = this.mediaStream
        this.$refs.video.play()
        this.track = this.mediaStream.getVideoTracks()[0]
        this.imageCapture = new ImageCapture(this.track)
      }
      this.waitingForLoad = false
    } catch (e) {
      console.log(e)
      this.error = true
      this.waitingForLoad = false
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      scanDni: 'compradores/escanearDni'
    }),
    async grabFrame () {
      this.waitingForLoad = true
      try {
        const blob = await this.imageCapture.takePhoto()
        var fileReader = new FileReader()
        fileReader.onload = async (event) => {
          try {
            this.base64 = event.target.result.replace('data:image/png;base64,', '')
            let result = await this.scanDni(this.base64)
            this.$emit('rellenar', result)
            this.waitingForLoad = false
            this.$parent.hide()
          } catch (e) {
            this.waitingForLoad = false
            this.addAlert({texto: this.$t('reservas.comprador.scannerError'), color: 'error'})
          }
        }
        fileReader.readAsDataURL(blob)
      } catch (e) {
        this.waitingForLoad = false
        this.addAlert({texto: this.$t('reservas.comprador.camaraError'), color: 'error'})
        console.log(e)
      }
    },
    async grabFrameiOS () {
      this.waitingForLoad = true
      await this.$nextTick()
      await this.$nextTick()
      try {
        let file = this.$refs.input.files[0]
        var fileReader = new FileReader()
        fileReader.onload = async (event) => {
          try {
            this.base64 = event.target.result
            let result = await this.scanDni(this.base64)
            this.$emit('rellenar', result)
            this.waitingForLoad = false
            this.$parent.hide()
          } catch (e) {
            this.waitingForLoad = false
            this.addAlert({texto: this.$t('reservas.comprador.scannerError'), color: 'error'})
          }
        }
        fileReader.readAsDataURL(file)
      } catch (e) {
        this.waitingForLoad = false
        this.addAlert({texto: this.$t('reservas.comprador.camaraError'), color: 'error'})
        console.log(e)
      }
    },
    salir () {
      this.$parent.hide()
    }
  },
  beforeDestroy () {
    if (this.track !== null) {
      this.track.stop()
    }
  },
  computed: {
    ...mapGetters({
      usuario: 'login/usuario'
    }),
    isiOS () {
      return /iPhone|Android|iPad|iPod/i.test(navigator.userAgent)
    }
  }
}
</script>
<style lang="stylus" scoped>
  #hiddenInput
    opacity 0
    position absolute
    right 0
    bottom 0
    width 5px
    height 5px
    display none
    cursor inherit
    pointer-events none
</style>




// WEBPACK FOOTER //
// src/components/reservas/comprador/DNIScanner.vue